import { feedblockTypes } from '@constants/index';

export const types = {
  LEGENDS_ON_UNACADEMY: 'legends_on_unacademy',
  GENERIC_BANNER: 'generic_banner',
  MY_DOWNLOADS: 'my_downloads'
};

export const isLegendsOnUnacademyType = (type) =>
  type === types.LEGENDS_ON_UNACADEMY;

export const isGenericBanner = (type) => type === types.GENERIC_BANNER;

export const isMyDownloadsType = (type) => type === types.MY_DOWNLOADS;

export const entityTypes = {
  COURSE: 'Course',
  EDUCATOR: 'Educator',
  SUBJECTS: 'Subjects',
  TEST_SERIES: 'TestSeries',
  TOPOLOGY: 'Topology',
  REFERRAL: 'Referral',
  BANNER: 'Banner',
  CAROUSEL: 'Carousel',
  CARD: 'Card',
  EXTERNAL_SUBSCRIPTION: 'ExternalSubscription',
  BATCH: 'Batch',
  CURATED_PLAYLIST: 'CuratedPlaylist'
};

export const isCourseEntityType = (type) => type === entityTypes.COURSE;
export const isEducatorEntityType = (type) => type === entityTypes.EDUCATOR;
export const isSubjectEntityType = (type) => type === entityTypes.SUBJECTS;
export const isTestSeriesEntityType = (type) =>
  type === entityTypes.TEST_SERIES;
export const isTopologyEntityType = (type) => type === entityTypes.TOPOLOGY;
export const isReferralEntityType = (type) => type === entityTypes.REFERRAL;
export const isBannerEntityType = (type) => type === entityTypes.BANNER;
export const isCarouselEntityType = (type) => type === entityTypes.CAROUSEL;
export const isCardEntityType = (type) => type === entityTypes.CARD;
export const isExternalSubscriptionEntityType = (type) =>
  type === feedblockTypes.EXT_SUBSCRIPTION_PREACTIVATION ||
  type === feedblockTypes.EXT_SUBSCRIPTION_POSTACTIVATION;
export const isBatchEntityType = (type) => type === entityTypes.BATCH;
export const isCuratedPlaylistEntityType = (type) =>
  type === entityTypes.CURATED_PLAYLIST;
export const isUpcomingClassFeed = (feedType) => feedType === 'upcoming';
